import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { db } from '../../../../firebase';
import { collection, onSnapshot } from 'firebase/firestore';
import { menuItemsLoadedAction } from '../../../actions/preloaded';
import { dataCompletedAction } from '../../../actions/store';

const useMenuItemsLoader = () => {
  const [options, setOptions] = useState({ execute: false });

  const dispatch = useDispatch();

  const load = () => {
    dispatch(dataCompletedAction({ slice: 'Preloaded', path: 'menuItems' }));
    return onSnapshot(
      collection(db, 'menu_items'),
      querySnapshot => {
        const allItems = [];

        querySnapshot.forEach(doc => {
          const dataItem = doc.data();
          dataItem.id = doc.id;
          allItems.push(dataItem);
        });

        dispatch(menuItemsLoadedAction(allItems));
      },
      error => {
        console.error('useMenuItemsLoader.onSnapshot', error);
      }
    );
  };

  useEffect(() => {
    let unSub = () => {};
    if (options.execute) {
      unSub = load();
    }
    return () => {
      unSub();
    };
  }, [options]);

  return {
    loadMenuItems: (options = {}) => {
      setOptions({ ...options, execute: true });
    }
  };
};

export default useMenuItemsLoader;
